<template>
    <div class="maintainer-list relative">
        <div class="buttons">
<!--            <el-button @click="reset">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
        </div>

        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="5" :xl="4" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">用户账户：</span>
                <el-input v-model="account" placeholder="搜索用户账户"></el-input>
            </el-col>
            <el-col :md="6" :lg="5" :xl="5" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">&ensp;&ensp;&ensp;&ensp;姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索" style="width: 100%;"/>
            </el-col>
            <el-col :md="6" :lg="5" :xl="4" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">角色：</span>
                <el-select
                    clearable
                    v-model="user_role" placeholder="请选择角色">
                    <el-option
                            v-for="item in allRole"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="5" :xl="4" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">操作记录：</span>
                <el-input v-model="search_data" placeholder="搜索操作记录关键词"></el-input>
            </el-col>
            <el-col :md="6" :lg="5" :xl="5" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">时间范围：</span>
                <el-date-picker
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                ></el-date-picker>
            </el-col>
            <el-col :md="6" :lg="5" :xl="4" :sm="6" :xs="6">
                <el-button @click="reset">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <el-table :data="tableData" border style="width: 100%">
<!--            <el-table-column prop="id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="80" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="140"  prop="account" label="用户账户" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="140" prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="220" prop="role_name" label="角色类型" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="160" prop="ip" label="登录ip" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="200" prop="create_time" label="操作日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="log_info" label="操作记录" align="center" label-class-name="label"></el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allRole: [],
                //搜索栏
                account: '',
                user_name: '',
                user_role: '',
                start_date: '',
                end_date: '',
                search_expired_date: '',
                search_data: '',
                is_submit: false,
            };
        },
        mounted() {
            //获取日志列表
            this.getList();
            this.getAllRole();
            localStorage.setItem('prev_page', 'log_list')
        },
        methods: {
            getAllRole() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'roleListing',
                    pageinfo: {},
                    params: {},
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    for (let i = 0; i < res.data.data.list.length; i++) {
                        if (res.data.data.list[i].id == 2) {
                            res.data.data.list.splice(i, 1);
                        }
                    }
                    this.allRole = res.data.data.list;
                });
            },

            //获取用户列表
            getList() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'adminLogListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        account: this.account,
                        user_name: this.user_name,
                        user_role: this.user_role,
                        search_data: this.search_data,
                        start_date: this.start_date,
                        end_date: this.end_date,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    let len = res.data.data.list.length
                    for (var i = 0; i < len; i++) {
                        // 序号
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].user_role) {
                            case '1':
                                res.data.data.list[i].user_role = '用户';
                                break;
                            case '1':
                                res.data.data.list[i].user_role = '子账户';
                                break;
                            case '3':
                                res.data.data.list[i].user_role = '特属专家';
                                break;
                            case '4':
                                res.data.data.list[i].user_role = '健康管理助理';
                                break;
                            case '5':
                                res.data.data.list[i].user_role = '运营';
                                break;
                        }
                        // res.data.data.list[i].log_info = res.data.data.list[i].action_name + res.data.data.list[i].operate_id;

                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            dateChange(e){
                if (!e) {
                    this.search_expired_date = null
                    this.start_date = ''
                    this.end_date = ''
                }
            },
            //搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }
                this.is_submit = true;
                this.page = 1;
                this.getList();
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            reset() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.account = '';
                this.user_name = '';
                this.user_role = '';
                this.search_data = '';
                this.start_date = "";
                this.end_date = "";
                this.search_expired_date = "";
                this.getList();
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";
</style>

